import React from 'react'
import { BUMP_UP, mq } from 'marketing-site/src/library/utils'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { CTALink } from 'marketing-site/src/mvp/library/elements/CTALink'
import classNames from 'classnames'
import kebabCase from 'lodash'

export const IconCard: React.FC<IProps> = ({ title, subhead, icon, cta, backgroundColor }) => {
  const classes = classNames('icon-card', {
    [`mvp-background-color-${kebabCase(backgroundColor)}`]: backgroundColor,
  })

  return (
    <div className={classes}>
      <div className="icon-card__content">
        {icon && <div className="icon-card__icon">{icon}</div>}

        <div className="icon-card__title">
          <Text size="heading-3">{title}</Text>
        </div>

        {subhead && (
          <div className="icon-card__subhead">
            <Text size="body">{subhead}</Text>
          </div>
        )}

        <div className="icon-card____cta">
          <CTALink {...cta} />
        </div>
      </div>

      <style jsx>
        {`
          .icon-card {
            display: grid;
            grid-column: 1/-1;
            padding: 1.75rem 1.5rem;
            border-radius: 0.5rem;
            color: var(--mvp-slate);
            transition: ${BUMP_UP.TRANSITION};

            &:hover {
              transform: ${BUMP_UP.TRANSFORM};
            }

            &__icon {
              text-align: left;
              :global(img) {
                width: 32px;
                height: 32px;
                margin-bottom: 1.5rem;
              }
            }
            &__title {
              margin-bottom: 1rem;
            }
            &__subhead {
              margin-bottom: 1.5rem;
            }
          }

          @media (${mq.tablet}) {
            .icon-card {
              grid-column: 1/-7;
              padding: 2.25rem 2rem;

              &__subhead {
                margin-bottom: 2rem;
              }
            }
          }

          @media (${mq.laptop}) {
            .icon-card {
              grid-column: 1/-9;
            }
          }
        `}
      </style>
    </div>
  )
}
